import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
import { Button } from "reactstrap"
import "react-multi-date-picker/styles/backgrounds/bg-dark.css"

export default class Reports extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'report',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: '',
            filters: {
                comId: 0,
                type: -1,
                fasl:0,
                startDate: null,
                startDateM: null,
                endDate: null,
                endDateM: null,
            }

        };

    }
    setTypeRec(v) {
        this.state.filters.type = v;
        this.setState({ data: this.state.data });
    }
    setTypeFasl(v) {
        this.state.filters.fasl = v;
        this.setState({ data: this.state.data });
    }
    setStartDate(v) {
        if (v != null) {
            let data = v.toString();
            this.state.filters.startDate = data;
            this.state.filters.startDateM = v.toDate();
        }
        else {
            this.state.filters.startDate = null;
            this.state.filters.startDateM = null;
        }

        this.setState({ data: this.state.data });
    }
    setEndDate(v) {
        if (v != null) {
            let data = v.toString();
            this.state.filters.endDate = data;
            this.state.filters.endDateM = v.toDate();
        }
        else {
            this.state.filters.endDate = null;
            this.state.filters.endDateM = null;
        }

        this.setState({ data: this.state.data });
    }


    recoveryData(e) {
        this.state.phrase = "";
        this.state.filters.comId = 0;
        this.state.filters.fasl = 0;
        this.state.filters.type = -1;
        this.state.filters.startDateM = null;
        this.state.filters.startDate = null;
        this.state.filters.endDateM = null;
        this.state.filters.endDate = null;
        this.refreshData(e);
    }

    loadLookupUnit(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getpersons/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    componentDidMount() {
        this.refreshData();
    }



    renderForm() {
        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block-head nk-block-head-sm">
                   
                    </div>
                    <div className="nk-block">
                        <div className="card card-bordered card-stretch">
                            <div className="card-inner-group">
                                <div className="card-inner position-relative card-tools-toggle">
                                    <div className="card-title-group">
                                        <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                            <div className="form-inline flex-nowrap">
                                                <div className="row g-3">
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">انتخاب مشتری</label>
                                                            <div className="form-control-wrap">
                                                                <SelectAsync

                                                                    defaultValue={this.state.filters.comId > 0 ? [{ value: this.state.filters.comId, label: this.state.filters.coTitle }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب مشتری"
                                                                    defaultOptions
                                                                    isSearchable
                                                                    loadOptions={this.loadLookupUnit}
                                                                    onChange={e => this.state.filters.comId = e.value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                   
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ شروع</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker
                                                                    className="bg-dark"
                                                                    value={this.state.filters.startDateM}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "34px",
                                                                        fontSize: "14px",
                                                                        padding: "3px 10px",
                                                                       

                                                                    }}

                                                                    onChange={e => this.setStartDate(e)}
                                                                    calendar={persian}
                                                                    locale={persian_fa} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ پایان</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker
                                                                    className="bg-dark"
                                                                    value={this.state.filters.endDateM}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "34px",
                                                                        fontSize: "14px",
                                                                        padding: "3px 10px",
                                                                       

                                                                    }}

                                                                    onChange={e => this.setEndDate(e)}
                                                                    calendar={persian}
                                                                    locale={persian_fa} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">نوع فاکتور</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" type="text" defaultValue={this.state.filters.type} onChange={e => this.setTypeRec(parseInt(e.target.value))}>
                                                                    <option value="0">انتخاب وضعیت</option>
                                                                    <option value="1">فروش</option>
                                                                    <option value="3">طلاجواهر و پلاتین</option>
                                                                    <option value="2">فروش ارز</option>
                                                                    <option value="4">پیمانکاری</option>
                                                                    <option value="5">قبوض خدماتی</option>
                                                                    <option value="6">بلیط هواپیما</option>
                                                                    <option value="7">صادرات</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">نوع فصل</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" type="text" defaultValue={this.state.filters.fasl} onChange={e => this.setTypeFasl(parseInt(e.target.value))}>
                                                                    <option value="0">انتخاب وضعیت</option>
                                                                    <option value="1">بهار</option>
                                                                    <option value="2">تابستان</option>
                                                                    <option value="3">پاییز</option>
                                                                    <option value="4">زمستان</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">برای فیلتر کردن دیکه جستجو را بزنید</label>
                                                            <div className="form-control-wrap">
                                                                <div className="btn-wrap">
                                                                    <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجوی اطلاعات </button></span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">بازیابی اطلاعات</label>
                                                            <div className="form-control-wrap">
                                                                <div className="btn-wrap">
                                                                    <span className="d-none d-md-block">
                                                                        <Button onClick={e => this.recoveryData(e)} className="btn-dim" outline color="info"><em class="icon ni ni-search"></em> بازیابی اطلاعات  </Button>

                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <br></br>

                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text text-center">ردیف</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">الگو</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">موضوع</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">نوع</span></div>
                                            <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">سریال</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">شماره منحصربفرد مالیاتی</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">شماره مالیاتی مرجع</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">تاریخ</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">طرف حساب</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">مبلغ کل</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">وضعیت</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.genRowNumber(index)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.inpString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.insString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.intyString}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-sm">
                                                    <span className="sub-text text-center">{record.inno}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.taxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.irtaxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center">{record.indatimPersian}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center">{record.customerName}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center">{this.money(record.tbill)}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">
                                                    {record.status === 1 && <span class="tb-status text-info">{record.statusString}</span>}
                                                    {record.status === 2 && <span class="tb-status text-warning">{record.statusString}</span>}
                                                    {record.status === 3 && <span class="tb-status text-danger">{record.statusString}</span>}
                                                    {record.status === 4 && <span class="tb-status text-success">{record.statusString}</span>}
                                                </div>
                                        
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.createPaging()}

                                <br />
                                <div className="card-inner position-relative card-tools-toggle">
                                    <div className="card-title-group">

                                            <div className="form-inline flex-nowrap">
                                                <div className="row g-3">
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">جمع بدون احتساب</label>
                                                        <div className="form-control-wrap">
                                                            <input type="text" className="form-control" type="text" value={this.state.data.sumNoTax} />

                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">جمع مالیات</label>
                                                            <div className="form-control-wrap">
                                                            <input type="text" className="form-control" type="text" value={this.state.data.tax} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">جمع کلی با احتساب مالیات</label>
                                                        <div className="form-control-wrap">
                                                            <input type="text" className="form-control" type="text" value={this.state.data.sumAll} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                    </div>
                                </div>
                                <div className="card-inner position-relative card-tools-toggle">
                                    <div className="card-title-group">

                                        <div className="form-inline flex-nowrap">
                                            <div className="row g-3">

                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">جمع فاکتور سکه</label>
                                                        <div className="form-control-wrap">
                                                            <input type="text" className="form-control" type="text" value={this.state.data.finalSeke} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">جمع فاکتور طلا</label>
                                                        <div className="form-control-wrap">
                                                            <input type="text" className="form-control" type="text" value={this.state.data.finalGold} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
                {!this.isBlank(this.state.Id_to_remove) &&
                    <div className="modalBg">
                        <div className="modalInner">
                            <p>آیا از حذف آیتم انتخابی مطمئن هستید؟</p>
                            <button className="btn btn-danger" onClick={e => { this.remove(); }}>بله</button>
                            <button className="btn btn-primary mr-r-10" onClick={e => { this.setState({ id_to_remove: null }); }}>انصراف</button>
                        </div>
                    </div>
                }
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}